import React, { FunctionComponent, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getDistrictAccessDataSettings,
  getSchools,
  getTeachers,
  openDistrictAccessDataSettingUpsertModal,
  updateSelectedUserData,
} from "../../../../../store/onboarding/actions";
import LoadingIndicator from "../../../../common/onboarding/LoadingIndicator";
import { ApplicationState } from "../../../../../store";
import DataAccessTable from "./DataAccessTable";
import DistrictAccessDataSettingUpsertModal from "./DistrictAccessDataSettingUpsertModal";
import { UserAssignmentRole, UserInfo } from "../../../../../store/auth/types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faSearch } from "@fortawesome/free-solid-svg-icons";
import { DistrictAccessDataSetting, TeacherInfo } from "../../../../../store/onboarding/types";
import FilterPanel from "../your-staff/manage-users-page/FilterPanel";
import { Form, InputGroup, OverlayTrigger, Tooltip } from "react-bootstrap";
import { changeSearchFilter } from "../../../../../store/onboarding/users-management/actions";

type OwnProps = {};

type Props = OwnProps;

const DataAccessPage: FunctionComponent<Props> = (props) => {
  const dispatch = useDispatch();
  const [selectedUsers, setSelectedUsers] = useState<any>([]);

  useEffect(() => {
    dispatch(getSchools());
    dispatch(getTeachers());
    dispatch(getDistrictAccessDataSettings());
    dispatch(changeSearchFilter(''));
  }, []);

  useEffect(() => {
    dispatch(updateSelectedUserData(selectedUsers))
  },[selectedUsers])

  const teachersRoster = useSelector<ApplicationState, TeacherInfo[]>(
    (s) => s.onboarding.teachersRoster
  );
  const districtAccessDataSettings = useSelector<
    ApplicationState,
    DistrictAccessDataSetting[]
  >((s) => s.onboarding.districtAccessDataSettings);

  const educators = useMemo(() => {
    return teachersRoster
      .filter(
        (t) =>
          t.user.profile.current_role === UserAssignmentRole.TEACHER ||
          t.user.profile.current_role === UserAssignmentRole.COACH
      )
      .map((t) => t.user);
  }, [teachersRoster]);


  const settings = useMemo(() => {
    return !educators.every((educator) => districtAccessDataSettings.find((s) => s.user === educator.id));
  }, [educators, districtAccessDataSettings]);

  const searchFilter = useSelector<ApplicationState, string>(
    (s) => s.usersManagement.searchFilter!
  );

  const handleSearchFilterChange = (event: React.FormEvent<any>) => {
    event.preventDefault();
    const { value } = event.target as HTMLInputElement;
    dispatch(changeSearchFilter(value));
  };

  const handleEdit = (
    educator: UserInfo,
    setting?: any
  ) => () => {
    dispatch(
      openDistrictAccessDataSettingUpsertModal(
        setting ? { ...(setting as any), user: educator } : { user: educator }
      )
    );
  };

  const loadingGetTeachers = useSelector<ApplicationState, boolean | undefined>(
    (s) => s.onboarding.isLoading.getTeachers
  );

  const loadingGetDistrictAccessDataSettings = useSelector<
    ApplicationState,
    boolean | undefined
  >((s) => s.onboarding.isLoading.getDistrictAccessDataSettings);
  return (
    <div className="manageDistrictContainer mb-4">
      <h2 className="font-weight-bold mb-2">Manage Data Permissions</h2>
      <h4>Set and update user permissions for accessing student data.</h4>
      <div className="my-3">{settings ? <span className="alert alert-warning py-1 px-1">Some users don’t have permissions yet. Please select the user(s) and click MANAGE PERMISSIONS to set them.</span>: ''} </div>
      <div className="d-flex justify-content-between align-items-end mt-3">
        <InputGroup className="filterSearchDesktop"  style={{width:"300px"}}>
          <InputGroup.Prepend>
            <InputGroup.Text>
              <FontAwesomeIcon icon={faSearch} />
            </InputGroup.Text>
          </InputGroup.Prepend>
          <Form.Control
            type="text"
            placeholder="Search"
            value={searchFilter as any}
            onChange={handleSearchFilterChange}
            className="filterSearchHeight"
          />
        </InputGroup>
        <OverlayTrigger
          overlay={
            <Tooltip id="manage-permissions-tooltip" className="customInfoTooltip">
              Create/Update Data Permissions
            </Tooltip>
          }
        >
          <button
            className="blueBtnSm float-right"
            type="button"
            disabled={!selectedUsers.length}
            onClick={handleEdit(selectedUsers)}
          >Manage Permissions</button>
        </OverlayTrigger>
      </div>
      <hr/>
      {loadingGetTeachers || loadingGetDistrictAccessDataSettings ? (
        <LoadingIndicator type="table" rows={20} columns={12} />
      ) : (
        <DataAccessTable selectedUsers = {selectedUsers} setSelectedUsers = {setSelectedUsers}/>
      )}
      <DistrictAccessDataSettingUpsertModal isShowDisabled={false} />
    </div>
  );
};

export default DataAccessPage;
